import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'backlog.flags.transition-and-rank-failure.title',
		defaultMessage: "We couldn't move your card",
		description: 'Title of card transition and rank failure flag',
	},
});
